import { useEffect, useState } from "react";
import { HOURS } from "@/lib/site";

const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const stockholmNow = () => {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/Stockholm",
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(new Date());
  const get = (t) => parts.find((p) => p.type === t).value;
  return { day: WEEKDAYS.indexOf(get("weekday")), minutes: Number(get("hour")) * 60 + Number(get("minute")) };
};

export const hoursForDay = (day) => HOURS.find((h) => h.days.includes(day));

export const getStatus = () => {
  const { day, minutes } = stockholmNow();
  const today = hoursForDay(day);
  const isOpen = minutes >= today.open * 60 && minutes < today.close * 60;
  let detail;
  if (isOpen) detail = `Stänger kl. ${today.close}`;
  else if (minutes < today.open * 60) detail = `Öppnar idag kl. ${today.open}`;
  else detail = `Öppnar i morgon kl. ${hoursForDay((day + 1) % 7).open}`;
  const detailType = isOpen ? "closes" : minutes < today.open * 60 ? "opensToday" : "opensTomorrow";
  const detailHour = isOpen ? today.close : minutes < today.open * 60 ? today.open : hoursForDay((day + 1) % 7).open;
  return { day, isOpen, detail, detailType, detailHour, today };
};

export const useOpenStatus = () => {
  const [status, setStatus] = useState(getStatus);
  useEffect(() => {
    const id = setInterval(() => setStatus(getStatus()), 30000);
    return () => clearInterval(id);
  }, []);
  return status;
};
